<div
  class="d-flex align-items-center justify-content-betwee p-2"
  [ngClass]="{
    'bg-danger': isPlanExpired,
    'bg-warning': !isPlanExpired
  }"
  *ngIf="billingService?.showBillingBanner"
>
  <span
    class="flex-grow-1 text-center"
    [ngClass]="{
      'text-white': isPlanExpired
    }"
  >
    Free trial
    <ng-container *ngIf="isPlanExpired">ended</ng-container>
    <ng-container *ngIf="!isPlanExpired">will end</ng-container>
    on {{ billingService?.growthPlan?.trialEndExpiryDisplayDate }} ({{
      billingService?.growthPlan?.trialEnd | timeago
    }}).
  </span>
  <span>
    <a
      [routerLink]="['billing']"
      [ngClass]="{
        'text-white': isPlanExpired
      }"
    >
      Manage Billing
    </a>
  </span>
</div>
